import { render, staticRenderFns } from "./LclDangerText.vue?vue&type=template&id=08170a30&scoped=true"
import script from "./LclDangerText.vue?vue&type=script&lang=js"
export * from "./LclDangerText.vue?vue&type=script&lang=js"
import style0 from "./LclDangerText.vue?vue&type=style&index=0&id=08170a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08170a30",
  null
  
)

export default component.exports